/*
 * LW (2026-10-07): "Claim my free mockup" buttons (any link to #form-jump) scroll to the
 * Globo form AND open it: Globo's first step is only a "CLAIM MY FREE MOCKUP" button, so
 * when the form is still on that step we press it for the visitor, landing them on the
 * fields. Falls back to the plain anchor jump if the form isn't on the page.
 */
(() => {
  const headerOffset = () => {
    const h = [...document.querySelectorAll('header-component, .header, #header-group > *, header')].find((el) => el.offsetHeight > 0);
    return Math.max(h ? h.getBoundingClientRect().height : 0, 60) + 16;
  };
  const visible = (el) => { const r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== 'hidden'; };
  document.addEventListener('click', (e) => {
    const a = e.target instanceof Element ? e.target.closest('a[href$="#form-jump"]') : null;
    if (!a) return;
    const url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname) return;
    const jump = document.getElementById('form-jump');
    if (!jump) return;
    e.preventDefault();
    const form = jump.parentElement?.querySelector('.globo-formbuilder') || document.querySelector('.globo-formbuilder');
    // Land on the note just above the form when there is one (it names the selected pack),
    // otherwise on the form itself.
    const note = document.querySelector('lwp-pack-tier:has(.lwp-pack-tier__note)');
    const target = note && form && note.compareDocumentPosition(form) & Node.DOCUMENT_POSITION_FOLLOWING ? note : form || jump;
    if (form) {
      const fields = [...form.querySelectorAll('input[type=text],input[type=email],input[type=tel],textarea')].filter(visible);
      const next = form.querySelector('.action.next');
      if (!fields.length && next && visible(next)) next.click();
      // data-lw-interest="Custom Quote" preselects the form's "What are you interested in?" option.
      const want = (a.dataset.lwInterest || '').toLowerCase();
      if (want) {
        setTimeout(() => {
          if (window.lwSetIntent) window.lwSetIntent(want);
          else for (const sel of form.querySelectorAll('select')) {
            const opt = [...sel.options].find((o) => o.text.trim().toLowerCase().includes(want));
            if (opt) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); break; }
          }
          // Globo can nudge the scroll position on change; settle back on the target.
          setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
        }, 350);
      }
    }
    // Works whether the page scrolls the window (mobile) or Horizon's inner wrapper (desktop).
    requestAnimationFrame(() => {
      target.style.scrollMarginTop = headerOffset() + 'px';
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    history.replaceState(null, '', '#form-jump');
  });
})();
